import camelCase from 'lodash/camelCase'
import memberFacingCampaignFormGetters from '@/campaign-form-shared/store/getters'

export default {
  ...memberFacingCampaignFormGetters,

  contentForNextField: (state, getters) => {
    return state.content[getters.nextField]
  },

  currentFieldIdx: (state, getters) => {
    return getters.filteredFields.indexOf(state.currentField)
  },

  currentlyShownFields: (_state, getters) => {
    return getters.filteredFields.slice(0, getters.currentFieldIdx + 1)
  },

  filteredFields: (state) => {
    // We don't display the partnership field if the petition is staff-led
    if (state.values.staffLedCampaign) {
      return state.allFields.filter((field) => field !== 'partnershipId')
    } else {
      return state.allFields
    }
  },

  firstFieldWithError: (state, getters) => {
    if (Object.keys(state.validationErrors).length === 0) {
      return null
    }

    for (let fieldIndex in getters.filteredFields) {
      const fieldName = getters.filteredFields[fieldIndex]
      if (state.validationErrors[camelCase(fieldName)]) {
        return fieldName
      }
    }

    throw `Could not find field for validation error. Validation errors: ${JSON.stringify(state.validationErrors)}`
  },

  lastShownField: (_state, getters) => {
    const shownFields = getters.currentlyShownFields
    return shownFields[shownFields.length - 1]
  },

  nextField: (_state, getters) => {
    return getters.filteredFields[getters.currentFieldIdx + 1]
  },

  onFirstField: (_state, getters) => {
    return getters.currentFieldIdx === 0
  },

  onLastField: (state, getters) => {
    return getters.currentFieldIdx + 1 === getters.filteredFields.length
  },

  pendingGeocodingOnNextSubmit: (state) => {
    // Location field is visible, user chose 'local' option but geocoded location is missing
    return state.values.locationKind === 'local' &&
      (!state.values.location || !state.values.location.latitude)
  },

  progressPercentage: (state, getters) => {
    // This is the case before the index, fields are initialized and
    // returning 0 before initialization is necessary to make the
    // progress bar animate from 0 to the actual value (instead of from 100%).
    if (getters.currentFieldIdx === getters.filteredFields.length) {
      return 0
    }
    // Starts with it partially filled in (1 / (#fields + 1))
    return (getters.currentFieldIdx + 1) / (getters.filteredFields.length + 1) * 100
  },

  trackingEventDataForCurrentField: (state, getters) => {
    return {
      action: `${getters.lastShownField}-field-shown`,
      category: 'petition-start-form'
    }
  },

  trackingEventNameForCurrentField: (_state, getters) => {
    return `${getters.lastShownField} Field Shown`
  }
}
